import React from 'react';
import PropTypes from 'prop-types';
import {
  Cell,
  Pie,
  PieChart,
  ResponsiveContainer,
  Tooltip,
} from 'recharts';
import styles from './DashboardChart.module.scss';

const DashboardDonut = ({ data, centerLabel }) => (
  <div>
    <div className={styles.chartFrame} role="img" aria-label={centerLabel}>
      <ResponsiveContainer width="100%" height={250}>
        <PieChart>
          <Pie
            data={data}
            dataKey="value"
            nameKey="name"
            cx="50%"
            cy="50%"
            innerRadius={68}
            outerRadius={94}
            paddingAngle={2}
            isAnimationActive={false}
          >
            {data.map((item) => <Cell key={item.name} fill={item.color} />)}
          </Pie>
          <Tooltip />
          <text x="50%" y="48%" textAnchor="middle" dominantBaseline="middle" fill="#1E2248" fontSize="28" fontWeight="650">
            {centerLabel}
          </text>
        </PieChart>
      </ResponsiveContainer>
    </div>
    <div className={styles.legend}>
      {data.map((item) => (
        <span key={item.name} className={styles.legendItem}>
          <i className={styles.legendDot} style={{ background: item.color }} />
          {item.name}
        </span>
      ))}
    </div>
  </div>
);

DashboardDonut.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired,
    color: PropTypes.string.isRequired,
  })).isRequired,
  centerLabel: PropTypes.string.isRequired,
};

export default DashboardDonut;
